import { render } from "./ExpensesItem.vue?vue&type=template&id=1ccca99a"
import script from "./ExpensesItem.vue?vue&type=script&lang=js"
export * from "./ExpensesItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__